import Indicators from '@/domain/drd/entity/indicators.entity';
import DateFormat from '@/shared/utils/date-format';
import KeyArea from './key-area.entity';
import KeyAreaSkill from './key-area-skill.entity';

export default class Drd {
  assignmentId: string;

  assignmentDescription: string;

  assignmentObjective: string;

  keyAreas: KeyArea[];

  indicators: Indicators[];

  drdModifiedDate: string;

  drdCreatedDate: string;

  revisionDate: string;

  roleName: string;

  ecosystem: string;

  skills: KeyAreaSkill[];

  constructor(obj: any = {}) {
    this.assignmentId = obj.assignmentId || '';
    this.assignmentDescription = obj.assignmentDescription || '';
    this.assignmentObjective = obj.assignmentObjective || '';
    this.keyAreas = obj.keyAreas
      ? obj.keyAreas.map(it => new KeyArea(it))
      : [];
    this.indicators = obj.indicators
      ? obj.indicators.map(it => new Indicators(it))
      : [];
    this.drdModifiedDate = DateFormat.dateTimeFormated(obj.drdModifiedDate) || '-';
    this.drdCreatedDate = DateFormat.dateTimeFormated(obj.drdCreatedDate) || '-';
    this.revisionDate = obj.revisionDate || '';
    this.roleName = obj.roleName || '';
    this.ecosystem = obj.ecosystem || '';
    this.skills = obj.skills
      ? obj.skills.map(it => new KeyAreaSkill(it))
      : [];
  }

  get keyAreasActive() {
    return this.keyAreas.filter(it => it.active);
  }

  get activeIndicators() {
    return this.indicators
      .filter(it => it.active);
  }
}
